module.exports = __webpack_public_path__ + "img/logo_txfq.0c9a1c96.png";